import { Outlet } from "react-router-dom";

function PublicLayout() { return <Outlet /> } 

export default PublicLayout;